import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Box, ChevronRight } from "lucide-react";
import { AttendanceParticipants } from "@/components/office/AttendanceParticipants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Targhetta "Sito Blue Box": card cliccabile (visibile solo se Blue Box è abilitato su almeno un appalto).
// Al click apre la gestione degli Utenti Presenze (context_type="blue_box", context_id=null), per appalto.
export function BlueBoxSites() {
  const [appalti, setAppalti] = useState([]);
  const attFlush = useRef(new Map());
  // Alla chiusura salva automaticamente i nominativi inseriti ma non ancora inviati.
  const onOpenChange = async (o) => {
    if (o) return setOpen(true);
    try {
      let n = 0;
      for (const f of attFlush.current.values()) n += await f();
      if (n) toast.success(`${n} Utenti Presenze salvati`);
      setOpen(false);
    } catch (e) { toast.error(e.message); }
  };
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/admin/attendance/bluebox-appalti").then((r) => setAppalti(r.data || [])).catch(() => setAppalti([]));
  }, []);
  if (!appalti.length) return null;
  return (
    <div className="mt-6" data-testid="bluebox-sites">
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="bluebox-card"
        className="w-full flex items-center gap-3 rounded-xl border border-[#BBD0F0] bg-[#F4F8FF] p-4 text-left transition-colors hover:bg-[#E9F1FF]"
      >
        <div className="h-11 w-11 rounded-lg bg-[#1E3A8A] flex items-center justify-center shrink-0"><Box className="h-5 w-5 text-white" /></div>
        <div className="flex-1 min-w-0">
          <h2 className="font-heading text-lg font-semibold text-slate-800">Sito Blue Box</h2>
          <p className="text-xs text-slate-500">Gestisci gli Utenti Presenze del servizio Blue Box · {appalti.length} appalt{appalti.length === 1 ? "o" : "i"}</p>
        </div>
        <ChevronRight className="h-5 w-5 text-slate-400 shrink-0" />
      </button>

      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="bluebox-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Box className="h-5 w-5 text-[#1E3A8A]" /> Sito Blue Box — Utenti Presenze</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            {appalti.map((a) => (
              <div key={a.id} className="rounded-xl border border-[#BBD0F0] bg-[#F4F8FF] p-4" data-testid={`bluebox-appalto-${a.id}`}>
                <p className="font-semibold text-slate-800 mb-1">{a.nome}</p>
                <AttendanceParticipants appaltoId={a.id} service="blue_box" contextType="blue_box" contextId={null} flushRef={attFlush} title="Utenti Presenze Blue Box" />
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default BlueBoxSites;
